import { render, staticRenderFns } from "./FilterPrescriptionInput.vue?vue&type=template&id=710615cd"
import script from "./FilterPrescriptionInput.vue?vue&type=script&lang=js"
export * from "./FilterPrescriptionInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports